import React from "react";
import { EVENT_STATES, STATE_ORDER } from "@/lib/eventState";

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

// Shared, identical filter controls for the homepage preview and the full /map page.
export function MapFilters({
  activeStates,
  onToggleState,
  categories = [],
  activeCategories,
  onToggleCategory,
  className = "",
}) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="map-filters">
      {STATE_ORDER.map((s) => {
        const on = activeStates.includes(s);
        return (
          <button
            key={s}
            data-testid={`map-filter-state-${s}`}
            onClick={() => onToggleState(s)}
            className={`flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${
              on
                ? "border-transparent text-white"
                : "border-border bg-white text-neutral-600 hover:bg-secondary"
            }`}
            style={on ? { backgroundColor: EVENT_STATES[s].color } : undefined}
          >
            <span
              className="h-2 w-2 rounded-full"
              style={{ backgroundColor: on ? "#ffffff" : EVENT_STATES[s].color }}
            />
            {EVENT_STATES[s].label}
          </button>
        );
      })}

      {categories.length > 0 && <span className="mx-1 h-5 w-px bg-border" />}

      {categories.map((c) => {
        const on = activeCategories.includes(c.key);
        return (
          <button
            key={c.key}
            data-testid={`map-filter-category-${c.key}`}
            onClick={() => onToggleCategory(c.key)}
            className={`flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${
              on ? "border-brand bg-brand/10 text-brand" : "border-border bg-white text-neutral-600 hover:bg-secondary"
            }`}
          >
            <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: c.color || "#94A3B8" }} />
            {cap(c.key)}
          </button>
        );
      })}
    </div>
  );
}

export default MapFilters;
